import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/Collection.css";
import WebsiteFooter from "../components/WebsiteFooter";
import TrainScroll from "../components/TrainScroll";
import Card from "../components/Card";

const Destination = ({ productsData, addToCart }) => {
    const [items, setItems] = useState([]);
    const [activeStation, setActiveStation] = useState(null);
    const navigate = useNavigate();
    const [origins, setOrigins] = useState([]);

    const handleNavigation = (product) => {
        const timestamp = new Date().toISOString();
        window.gtag("event", `Destination_${product}_viewed`, { 'timestamp': timestamp.toLocaleString(), "click": product })
        navigate(`/Product/${product}`);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const originMap = {}; // Temporary object to store categories
                productsData.forEach((product) => {
                    if (product.Origin) { // Only add if Origin is defined
                        originMap[product.Origin] = product.Img;
                    }
                });
    
                setOrigins(originMap); // Update state with valid origins only
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };
    
        fetchData();
    }, [productsData]);

    
    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const originMap = {}; // Temporary object to store categories
    //             productsData.forEach((product) => {
    //                 if (!originMap[product.Origin]) {
    //                     originMap[product.Origin] = product.Img;
    //                 }
    //             });

    //             setOrigins(originMap); // Merge with previous state
    //         }
    //         catch (error) {
    //             console.error("Error fetching categories:", error);
    //         }
    //     };

        //    try {
        //         if (!productsData || productsData.length === 0) return; // Exit if productsData is not available or empty

        //         // Filter items by destination name
        //         const filteredItems = productsData.filter(item => item.Origin === destinationName);
        //         const uniqueOrigins = []; // Temporary array to store unique origins
        //         productsData.forEach((product) => {
        //             if (!uniqueOrigins.includes(product.Origin)) {
        //                 uniqueOrigins.push(product.Origin);
        //             }
        //         });

        //         setOrigins(uniqueOrigins); // Update state with the unique origins


        //         setItems(filteredItems); // Update state with filtered items
        //     } catch (error) {
        //         console.error("Error fetching collection data:", error);
        //     }
        // };

    //     fetchData();
    // }, [productsData]); // Effect depends on destinationName and productsData

    useEffect(() => {
        if (activeStation) {
            const filteredItems = productsData.filter(
                (product) => product.Origin === activeStation
            );
            setItems(filteredItems);
        }
    }, [activeStation, productsData]);


    return (
        <>
            <div className="collections-container">
                <h5>Shop By Destination</h5>
                <p> Scroll to Explore Stations & Products </p>
                <TrainScroll origins={origins} productsData={productsData} onStationChange={setActiveStation} />
                {/* <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                {origins.map((origin) => (
                    <span
                        key={origin}
                        className={`${origin === destinationName ? "Shop_By_Selected" : "Shop_By"}`}
                        onClick={() => {
                            handleNavigation(`/Collections/Destination/${origin}`);
                        }}
                    >
                        {origin}
                    </span>
                ))}
            </div>*/}
                <div className="items-grid">
                    {items.length > 0 ? (
                        items.map((item, index) => (
                            <Card key={index} item={item} addToCart={addToCart} onClick={() => handleNavigation(item.Name)} />
                        ))
                    ) : (
                        <p>No items available for this destination</p>
                    )}
                </div>
            </div>
            <WebsiteFooter />
        </>
    );
};

export default Destination;
